import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { openNewTab, validateV2Styles } from '../../../../utilities/index';
import { API_WHATSAPP } from '../../../../constants/public.constant';
import microsoft1 from '../../../../assets/img/movil/6.jpg';
import next from '../../../../assets/img/movil/arrow.svg';
import microsoft2 from '../../../../assets/img/movil/banner25.jpg';
import bannerbit2 from '../../../../assets/img/movil/BitdefenderGold.png';
import bannerbit1 from '../../../../assets/img/movil/Fondblue.png';
import kapersky2 from '../../../../assets/img/movil/karpesky1.png';
import kapersk3 from '../../../../assets/img/movil/karpesky2.jpg';
import kapersky1 from '../../../../assets/img/movil/karpesky3.jpg';
import c1 from '../../../../assets/img/movil/Bitdefender Antivirus.png';
import c2 from '../../../../assets/img/movil/Kaspersky Antivirus.png';
import c3 from '../../../../assets/img/movil/Licenciamiento Microsoft.png';
import c4 from '../../../../assets/img/movil/Servicios de Infraestructura.png';
import c5 from '../../../../assets/img/movil/Soluciones de Networking.png';
import c6 from '../../../../assets/img/movil/Distribucion de Hardware.png';
import c8 from '../../../../assets/img/movil/Antispam.png';
import security1 from '../../../../assets/img/movil/Servicios-infraestructura.jpg';
import security2 from '../../../../assets/img/movil/Soluciones-Networking.jpg';
import partner1 from '../../../../assets/img/movil/Zebra_logo.png';
import partner2 from '../../../../assets/img/movil/MicrosoftTeams-image.png';
import partner3 from '../../../../assets/img/movil/Microsoft_logo_(2012).svg.png';
import partner4 from '../../../../assets/img/movil/Partner4.jpg';
import partner5 from '../../../../assets/img/movil/Partner5.jpg';
import partner6 from '../../../../assets/img/movil/Bitdefender-Logo.wine.png';
import partner7 from '../../../../assets/img/movil/Autodesk_Logo.svg.png';
import partner8 from '../../../../assets/img/movil/351497.png';
import partner9 from '../../../../assets/img/movil/350655.png';
import partner10 from '../../../../assets/img/movil/2048px-HP_New_Logo_2D.svg.png';
import partner11 from '../../../../assets/img/movil/1280px-Epson_logo.svg.png';
import partner12 from '../../../../assets/img/movil/1200px-Kaspersky_Lab_logo.svg.png';
import partner13 from '../../../../assets/img/movil/logo_heimdal_security.png';
import partner14 from '../../../../assets/img/movil/Lenovo_logo_2015.svg.png';
import partner15 from '../../../../assets/img/movil/Partner15.jpg';
import partner16 from '../../../../assets/img/movil/Dell_Logo.svg.png';
import './CMHomeV2.css';

function CMHomeV2() {
    // DEBUG: Verificar que el componente se está renderizando
    useEffect(() => {
        if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
            // #region agent log
            fetch('http://127.0.0.1:7244/ingest/196f09a7-27bd-4831-a9ef-ab53d9b665ae',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CMHomeV2.tsx:44',message:'Componente CMHomeV2 renderizado',data:{width:window.innerWidth,elementExists:!!document.getElementById('CMHomeV2')},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
            // #endregion
            
            console.log('[CMHomeV2] ✅ Componente CMHomeV2 renderizado');
            console.log('[CMHomeV2]   - Elemento #CMHomeV2 existe:', !!document.getElementById('CMHomeV2'));
            console.log('[CMHomeV2]   - Ancho de ventana:', window.innerWidth);
            const element = document.getElementById('CMHomeV2');
            if (element) {
                const computedStyle = window.getComputedStyle(element);
                console.log('[CMHomeV2]   - Background:', computedStyle.backgroundColor);
                console.log('[CMHomeV2]   - Width:', computedStyle.width);
                console.log('[CMHomeV2]   - Isolation:', computedStyle.isolation);
                
                // #region agent log
                fetch('http://127.0.0.1:7244/ingest/196f09a7-27bd-4831-a9ef-ab53d9b665ae',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CMHomeV2.tsx:52',message:'Estilos computados del contenedor principal',data:{background:computedStyle.backgroundColor,width:computedStyle.width,isolation:computedStyle.isolation},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'A'})}).catch(()=>{});
                // #endregion
            }
            
            // Verificar orden de carga de CSS y estilos aplicados
            setTimeout(() => {
                const allStylesheets = Array.from(document.styleSheets);
                const cssOrder: string[] = [];
                allStylesheets.forEach((sheet: any) => {
                    try {
                        const href = sheet.href || 'inline';
                        if (href.includes('CMHome') || href.includes('App.css')) {
                            cssOrder.push(href);
                        }
                    } catch (e) {
                        // Ignorar errores de CORS
                    }
                });
                
                // #region agent log
                fetch('http://127.0.0.1:7244/ingest/196f09a7-27bd-4831-a9ef-ab53d9b665ae',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CMHomeV2.tsx:65',message:'Orden de carga de CSS',data:{cssOrder:cssOrder},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'E'})}).catch(()=>{});
                // #endregion
                
                // Verificar estilos de elementos críticos
                const imgChecks = document.querySelectorAll('#CMHomeV2 .img-check');
                const pSubtitles = document.querySelectorAll('#CMHomeV2 .p-subtitle');
                
                if (imgChecks.length > 0) {
                    const firstImg = imgChecks[0] as HTMLElement;
                    const imgStyle = window.getComputedStyle(firstImg);
                    const appliedRules = getAppliedCSSRules(firstImg);
                    
                    // #region agent log
                    fetch('http://127.0.0.1:7244/ingest/196f09a7-27bd-4831-a9ef-ab53d9b665ae',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CMHomeV2.tsx:75',message:'Estilos de .img-check',data:{width:imgStyle.width,height:imgStyle.height,marginTop:imgStyle.marginTop,appliedRules:appliedRules},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
                    // #endregion
                }
                
                if (pSubtitles.length > 0) {
                    const firstP = pSubtitles[0] as HTMLElement;
                    const pStyle = window.getComputedStyle(firstP);
                    const appliedRules = getAppliedCSSRules(firstP);
                    
                    // #region agent log
                    fetch('http://127.0.0.1:7244/ingest/196f09a7-27bd-4831-a9ef-ab53d9b665ae',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CMHomeV2.tsx:85',message:'Estilos de .p-subtitle',data:{fontSize:pStyle.fontSize,width:pStyle.width,textAlign:pStyle.textAlign,appliedRules:appliedRules},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'C'})}).catch(()=>{});
                    // #endregion
                }
                
                // Verificar estilos globales
                const bodyStyle = window.getComputedStyle(document.body);
                const htmlStyle = window.getComputedStyle(document.documentElement);
                
                // #region agent log
                fetch('http://127.0.0.1:7244/ingest/196f09a7-27bd-4831-a9ef-ab53d9b665ae',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({location:'CMHomeV2.tsx:95',message:'Estilos globales',data:{bodyBackground:bodyStyle.backgroundColor,htmlBackground:htmlStyle.backgroundColor},timestamp:Date.now(),sessionId:'debug-session',runId:'run1',hypothesisId:'B'})}).catch(()=>{});
                // #endregion
                
                console.log('[CMHomeV2] 🔍 Ejecutando validación de estilos...');
                validateV2Styles();
            }, 500);
        }
    }, []);
    
    // Función auxiliar para obtener reglas CSS aplicadas
    const getAppliedCSSRules = (element: HTMLElement): Array<{selector: string, source: string, specificity: string}> => {
        const rules: Array<{selector: string, source: string, specificity: string}> = [];
        
        try {
            const allStylesheets = Array.from(document.styleSheets);
            allStylesheets.forEach((sheet: any) => {
                try {
                    const href = sheet.href || 'inline';
                    const cssRules = Array.from(sheet.cssRules || sheet.rules || []);
                    cssRules.forEach((rule: any) => {
                        try {
                            if (rule.selectorText) {
                                let matches = false;
                                try {
                                    matches = element.matches(rule.selectorText);
                                } catch (e) {
                                    try {
                                        const parent = element.parentElement;
                                        if (parent) {
                                            matches = parent.querySelector(rule.selectorText) === element;
                                        }
                                    } catch (e2) {
                                        // Ignorar
                                    }
                                }
                                
                                if (matches) {
                                    const source = href.includes('CMHome.css') ? 'CMHome.css (v1)' : 
                                                  href.includes('CMHomeV2.css') ? 'CMHomeV2.css (v2)' : 
                                                  href.includes('App.css') ? 'App.css' : href;
                                    rules.push({
                                        selector: rule.selectorText,
                                        source: source,
                                        specificity: calculateSpecificity(rule.selectorText)
                                    });
                                }
                            }
                        } catch (e) {
                            // Ignorar errores
                        }
                    });
                } catch (e) {
                    // Ignorar errores de CORS
                }
            });
        } catch (e) {
            console.warn('No se pudieron obtener todas las reglas:', e);
        }
        
        return rules;
    };
    
    // Función auxiliar para calcular especificidad CSS
    const calculateSpecificity = (selector: string): string => {
        let a = 0, b = 0, c = 0;
        const parts = selector.split(/\s+/);
        parts.forEach(part => {
            // IDs
            a += (part.match(/#/g) || []).length;
            // Clases, atributos, pseudo-clases
            b += (part.match(/\.|\[|:/g) || []).length;
            // Elementos
            c += (part.match(/^[a-zA-Z]/g) || []).length;
        });
        return `${a}-${b}-${c}`;
    };

    const navigate = useNavigate();
    const [stPartners] = useState([partner1, partner2, partner3, partner4, partner5, partner6, partner7, partner8, partner9, partner10, partner11, partner12, partner13, partner14, partner15, partner16]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const totalSlides = 3;

    useEffect(() => {
        let idInterval = setInterval(() => {
            if (window.location.pathname === "/") {
                try {
                    movercarruselpartner("derecha");
                } catch(e) {
                    window.location.reload();
                }
            } else {
                window.clearInterval(idInterval);
            }
        }, 5000);
        return () => clearInterval(idInterval);
    }, []);

    function movercarruselpartner(direccion: string) {
        let stContenidoPartner: any = document.getElementById("CMH2-partner-carrusel");

        if (direccion === "derecha") {
            let itemPrimeropartner = stContenidoPartner.childNodes[0];

            if (window.innerWidth < 580) {
                stContenidoPartner.style.marginLeft = "-100%";
            }
            else {
                stContenidoPartner.style.marginLeft = "-66.66%";
            }
            stContenidoPartner.style.transition = "all .5s";

            setTimeout(() => {
                stContenidoPartner.style.transition = "none";
                stContenidoPartner.insertAdjacentElement('beforeend', itemPrimeropartner);

                if (window.innerWidth < 580) {
                    stContenidoPartner.style.marginLeft = "-50%";
                }
                else {
                    stContenidoPartner.style.marginLeft = "-33.33%";
                }
            }, 500);
        }
        else {
            let itempartner = stContenidoPartner.childNodes;
            let itemfinalpartner = itempartner[itempartner.length - 1];

            stContenidoPartner.style.marginLeft = "0%";
            stContenidoPartner.style.transition = "all 0.5s"

            setTimeout(() => {
                stContenidoPartner.style.transition = "none";
                stContenidoPartner.insertAdjacentElement('afterbegin', itemfinalpartner);
                stContenidoPartner.style.marginLeft = "-50%";
            }, 500);
        }
    }

    function navigateView(name: string) {
        navigate("/" + name);
    }

    function openWhatsApp() {
        openNewTab(API_WHATSAPP);
    }

    return (
        <main id="CMHomeV2" data-version="v2">
            {/* Hero Section V2 Móvil */}
            <section id="CMH2-hero">
                <div id="CMH2-hero__pattern"></div>
                <div id="CMH2-hero__content">
                    <h1 id="CMH2-hero__title">Soluciones integrales en tecnología e infraestructura industrial</h1>
                    <p id="CMH2-hero__subtitle">Integramos tecnología, energía e ingeniería para garantizar continuidad operativa</p>
                    <div id="CMH2-hero__buttons">
                        <button id="CMH2-hero__btn-services" onClick={() => navigateView("")}>
                            Ver Servicios
                        </button>
                        <button id="CMH2-hero__btn-contact" onClick={() => navigateView("Contacto")}>
                            Contáctenos
                        </button>
                    </div>
                    <div id="CMH2-hero__indicators">
                        {[0, 1, 2].map((index) => (
                            <div
                                key={index}
                                className={`CMH2-indicator ${currentSlide === index ? 'CMH2-indicator-active' : ''}`}
                            />
                        ))}
                    </div>
                </div>
            </section>

            {/* Sección de Servicios V2 Móvil */}
            <section id="CMH2-services">
                <div id="CMH2-services__header">
                    <p id="CMH2-services__subtitle">NUESTRAS SOLUCIONES</p>
                    <h2 id="CMH2-services__title">Servicios Integrales para su Empresa</h2>
                    <p id="CMH2-services__description">Ofrecemos soluciones completas en tecnología e infraestructura industrial</p>
                </div>
                <button id="CMH2-services__whatsapp-btn" onClick={openWhatsApp}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" fill="white"/>
                    </svg>
                    Contáctenos vía WhatsApp
                </button>
                <ul id="CMH2-services__lista">
                    <li onClick={() => navigateView("Bitdefender")}>
                        <img className="img-check" src={c1} alt="Bitdefender" />
                        <p className="p-subtitle">Bitdefender Antivirus</p>
                    </li>
                    <li onClick={() => navigateView("Kaspersky")}>
                        <img className="img-check" src={c2} alt="Kaspersky" />
                        <p className="p-subtitle">Kaspersky Antivirus</p>
                    </li>
                    <li onClick={() => navigateView("Microsoft")}>
                        <img className="img-check" src={c3} alt="Microsoft" />
                        <p className="p-subtitle">Licenciamiento Microsoft</p>
                    </li>
                    <li onClick={() => navigateView("Infraestructura")}>
                        <img className="img-check" src={c4} alt="Infraestructura" />
                        <p className="p-subtitle">Servicios de Infraestructura</p>
                    </li>
                    <li onClick={() => navigateView("Networking")}>
                        <img className="img-check" src={c5} alt="Networking" />
                        <p className="p-subtitle">Soluciones en Networking</p>
                    </li>
                    <li onClick={() => navigateView("Hardware")}>
                        <img className="img-check" src={c6} alt="Hardware" />
                        <p className="p-subtitle">Distribucion de Hardware</p>
                    </li>
                    <li onClick={() => navigateView("ContinuidadElectrica")}>
                        <svg width="70" height="70" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 2L3 14H12L11 22L21 10H12L13 2Z" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <p className="p-subtitle">Continuidad Eléctrica</p>
                    </li>
                    <li onClick={() => navigateView("InfraestructuraElectrica")}>
                        <svg width="70" height="70" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18.36 6.64C19.6184 7.89879 20.4753 9.50244 20.8223 11.2482C21.1693 12.9939 20.9929 14.8034 20.3136 16.4478C19.6344 18.0921 18.4748 19.4975 16.9948 20.4864C15.5148 21.4753 13.7749 22.0029 11.995 22.0029C10.2151 22.0029 8.47515 21.4753 6.99513 20.4864C5.51511 19.4975 4.35559 18.0921 3.67634 16.4478C2.99708 14.8034 2.82079 12.9939 3.16779 11.2482C3.51479 9.50244 4.37172 7.89879 5.63 6.64" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M12 2V12" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <p className="p-subtitle">Infraestructura Eléctrica</p>
                    </li>
                    <li onClick={() => navigateView("MantenimientoIndustrial")}>
                        <svg width="70" height="70" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.7 6.3C15.09 6.69 15.09 7.32 14.7 7.71L9.71 12.7C9.32 13.09 8.69 13.09 8.3 12.7L5.29 9.7C4.9 9.31 4.9 8.68 5.29 8.29L10.29 3.29C10.68 2.9 11.31 2.9 11.7 3.29L14.7 6.3Z" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M19 12L12 19L5 12" stroke="#DDB70F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <p className="p-subtitle">Mantenimiento Industrial</p>
                    </li>
                    <li onClick={() => navigateView("Antispam")}>
                        <img className="img-check" src={c8} alt="Antispam" />
                        <p className="p-subtitle">Antispam</p>
                    </li>
                </ul>
            </section>

            {/* Resto de secciones - Mantener igual que CMHome pero con IDs V2 */}
            <section id="CMH2-bit">
                <figure id="CMH2-bit-fondo">
                    <img src={bannerbit1} alt="Infrasol SAC" />
                    <div id="CMH2-bit-content">
                        <div id="CMH2-bit-content__c1">
                            <h1 id="CMH2-bit-content__c1--h1">DESCUBRA LAS AMENAZAS EVASIVAS Y RESPONDA EFIZCAMENTE</h1>
                            <p id="CMH2-bit-content__c1--p1">Defienda su organizacion contra las amenazas digitales con capacidades de seguridad avanzadas integradas,
                                a un precio adecuado para su empresa.</p>
                            <p id="CMH2-bit-content__c1--p2">Somos Partner Gold, confie su seguridad en Bitdefender y proteja sus servidores y estaciones de trabajo.</p>
                        </div>
                        <figure id="CMH2-bit-content__c2">
                            <img src={bannerbit2} alt="Infrasol SAC" />
                        </figure>
                        <div id="CMH2-bit-content__c3">
                            <p onClick={() => navigateView("Bitdefender")}>Consultar</p>
                        </div>
                    </div>
                </figure>
            </section>

            <section id="CMH2-nosotros">
                <div id="CMH2-nosotros-title">
                    <div id="CMH2-nosotros-title__t1">
                        <p>NOSOTROS</p>
                    </div>
                    <div id="CMH2-nosotros-title__t2">
                        <p>Somos un equipo apasionado y<strong> dedicado de asesores y consultores.</strong></p>
                    </div>
                    <div id="CMH2-nosotros-title__t3">
                        <p>Comunicaciones, Infraestructura y Seguridad Informática</p>
                        <div>
                            <p onClick={() => navigateView("Nosotros")}>Conócenos</p>
                        </div>
                    </div>
                </div>
                <div id="CMH2-nosotros-bar">
                    <ul id="CMH2-nosotros-bar__lista">
                        <li>
                            <p>Bitdefender Antivirus 95% </p>
                            <div id="CMH2-bit-95"></div>
                        </li>
                        <li>
                            <p>Kapersky Antivirus 85% </p>
                            <div id="CMH2-kap-85"></div>
                        </li>
                        <li>
                            <p>Licenciamiento Microsoft 90% </p>
                            <div id="CMH2-mic-90"></div>
                        </li>
                        <li>
                            <p>Servicios de Infraestructura 85% </p>
                            <div id="CMH2-inf-85"></div>
                        </li>
                        <li>
                            <p>Distribucion de Hardware 90% </p>
                            <div id="CMH2-har-90"></div>
                        </li>
                        <li>
                            <p>Soluciones de Networking 90% </p>
                            <div id="CMH2-net-90"></div>
                        </li>
                    </ul>
                </div>
            </section>

            <section id="CMH2-kasp">
                <figure id="CMH2-kasp-fondo">
                    <img src={kapersky1} alt="Infrasol SAC" />
                    <div id="CMH2-kasp-content">
                        <div id="CMH2-kasp-c1">
                            <figure id="CMH2-kasp-content__c1">
                                <img src={kapersky2} alt="Infrasol SAC" />
                            </figure>
                            <div id="CMH2-kasp-content__c2">
                                <p onClick={() => navigateView("Kaspersky")}>Consultar</p>
                            </div>
                        </div>
                        <div id="CMH2-kasp-c2">
                            <figure id="CMH2-kasp-content__c3">
                                <img src={kapersk3} alt="Infrasol SAC" />
                            </figure>
                        </div>
                    </div>
                </figure>
            </section>

            <section id="CMH2-security">
                <div className="CMH2-security-item">
                    <img className="CMH2-security-item__img" src={security1} alt="Infrasol SAC" />
                    <div className="CMH2-security-item__div">
                        <p>Servicios de Infraestructura</p>
                        <span>Servicios integrales de gestión que dan respuesta a las necesidades de la plataforma de TI de las empresas.</span>
                    </div>
                </div>
                <div className="CMH2-security-item2">
                    <img className="CMH2-security-item__img" src={security2} alt="Infrasol SAC" />
                    <div className="CMH2-security-item__div2">
                        <p>Soluciones en Networking</p>
                        <span>Ofrece consultoría, gestión de proyectos, planificación, testeo, mantenimiento y soporte en Networking.</span>
                    </div>
                </div>
            </section>

            <section id="CMH2-microsoft">
                <figure id="CMH2-microsoft-fondo">
                    <img src={microsoft1} alt="Infrasol SAC" />
                    <div id="CMH2-microsoft-content">
                        <div id="CMH2-microsoft-content__c1">
                            <figure>
                                <img src={microsoft2} alt="Infrasol SAC" />
                            </figure>
                        </div>
                        <div id="CMH2-microsoft-content__c2">
                            <p onClick={() => navigateView("Microsoft")}>Consultar</p>
                        </div>
                    </div>
                </figure>
            </section>

            <section id="CMH2-partner">
                <div id="CMH2-partner-info">
                    <div id="CMH2-partner-info__div">
                        <p id="CMH2-partner-info__div--p1">Nuestros <strong> Partners.</strong></p>
                    </div>
                    <div id="CMH2-partner-info__carrusel">
                        <ul id="CMH2-partner-carrusel">
                            {
                                stPartners.map((item, index) => (
                                    <li key={index} className="CMH2-partner-carrusel--item">
                                        <img src={item} alt="Infrasol Partners" />
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default CMHomeV2;

